fragment CalendarFragment on CalendarSyncCalendar {
    id
    name
    isSelected
    syncType
    syncErrors
    username
    serviceType
    exportRule
    isContactCreationDisabled
}
